import { wait } from './wait';

export const timeoutAfter =
  (ms: number) =>
  <T>(p: T | Promise<T>) =>
    Promise.race([p, wait(ms)]);
